( function( $ ) {
    'use strict';
    
    /**
     * Show comments section (remove d-none class) on click
     */
    $(".view-comments-link, .leave-comment-link").click(function () {
        $("#comments-section").removeClass('d-none');
    });

    /**
    * initialize masonry layout
    */
    $( '.grid' ).imagesLoaded( function() {
        // images have loaded
        var $grid = $( '.grid' ).masonry({
            // options
            itemSelector: '.grid-item',
        });
    });

    /**
    * check if element exists then make it sticky
    */
    if ( $( '#sticky-sidebar' ).length > 0 ) {
        var sidebar =  new StickySidebar( '#sticky-sidebar', {
            containerSelector: '.row',
            innerWrapperSelector: '.sidebar__inner',
            topSpacing: 40,
            bottomSpacing: 0,
            minWidth: 767
        } );
    }

}(jQuery));